import { DetailedHTMLProps, HTMLAttributes } from 'react';
import Icon from '../icons/icon';
import './validation-error.scss';

export const ValidationError = ({
  children,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
  return (
    <div {...props}>
      <div className="validation-error">
        <Icon icon="InfoCircle" stroke="var(--error-500)" size="large" />
        {children}
      </div>
    </div>
  );
};
